import TransferSuccess from 'features/v2a/sender/screens/TransferSuccess/TransferSuccess';
import React from 'react';

export default function TransferSuccessPage() {
  return <TransferSuccess />;
}
